// Generated by Melange

import * as Buhta_cabinet__Link from "./Link.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(title) {
  return function (routeOpt) {
    const route = routeOpt !== undefined ? routeOpt : /* OrgChoose */0;
    return function (colorOpt) {
      const color = colorOpt !== undefined ? colorOpt : /* Blue */2;
      return function (onClickOpt) {
        const onClick = onClickOpt !== undefined ? onClickOpt : (function (param) {
              
            });
        return function (linkOpt) {
          const link = linkOpt !== undefined ? linkOpt : false;
          return function (className) {
            return function (disabledOpt) {
              const disabled = disabledOpt !== undefined ? disabledOpt : false;
              return function (urlParamsOpt) {
                const urlParams = urlParamsOpt !== undefined ? urlParamsOpt : /* [] */0;
                return function (textOpt) {
                  const text = textOpt !== undefined ? textOpt : /* He4 */0;
                  return function (type_Opt) {
                    const type_ = type_Opt !== undefined ? type_Opt : "button";
                    let colorStyle;
                    switch (color) {
                      case /* White */0 :
                          colorStyle = "bg-white border border-gray-main hover:bg-gray-pale";
                          break;
                      case /* Transparent */1 :
                          colorStyle = "bg-transparent border border-gray-main hover:bg-gray-pale";
                          break;
                      case /* Blue */2 :
                          colorStyle = "bg-links hover:bg-links-hover active:bg-links-active";
                          break;
                      
                    }
                    let textColorStr;
                    switch (color) {
                      case /* White */0 :
                      case /* Transparent */1 :
                          textColorStr = "text-black";
                          break;
                      case /* Blue */2 :
                          textColorStr = "text-white";
                          break;
                      
                    }
                    const textEl = text ? JsxRuntime.jsx(Buhta_components__Text.H5.make, {
                            className: Cn.fromList({
                                  hd: "text-center",
                                  tl: {
                                    hd: textColorStr,
                                    tl: /* [] */0
                                  }
                                }),
                            children: title
                          }) : JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                            className: Cn.fromList({
                                  hd: "text-center",
                                  tl: {
                                    hd: textColorStr,
                                    tl: /* [] */0
                                  }
                                }),
                            children: title
                          });
                    if (link) {
                      return JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                  route: route,
                                  className: Cn.$plus(Cn.$plus("rounded block", colorStyle), className),
                                  children: textEl,
                                  urlParams: urlParams
                                });
                    } else {
                      return JsxRuntime.jsx("button", {
                                  children: textEl,
                                  className: Cn.$plus(Cn.$plus("rounded block disabled:bg-default-gray disabled:cursor-not-allowed hover:border-default-gray active:border-gray-medium", colorStyle), className),
                                  disabled: disabled,
                                  type: type_,
                                  onClick: onClick
                                });
                    }
                  };
                };
              };
            };
          };
        };
      };
    };
  };
}

function Btn(Props) {
  return Curry._8(make(Props.title)(Props.route), Props.color, Props.onClick, Props.link, Props.className, Props.disabled, Props.urlParams, Props.text, Props.type_);
}

const make$1 = Btn;

export {
  make$1 as make,
}
/* Buhta_cabinet__Link Not a pure module */
